
export const isAsiaScaleKey = (scaleKey) =>
  typeof scaleKey === "string" && scaleKey.trim().toLowerCase() === "asia";

const motorSensoryHasAnySelection = (obj, depth = 0) => {
  if (!obj || typeof obj !== "object" || depth > 12) return false;
  for (const v of Object.values(obj)) {
    if (v != null && typeof v === "object" && !Array.isArray(v)) {
      if (motorSensoryHasAnySelection(v, depth + 1)) return true;
    } else if (v === "NT") return true;
    else if (typeof v === "number" && Number.isFinite(v)) return true;
  }
  return false;
};

const objectHasAnyPrimitive = (obj, depth = 0) => {
  if (!obj || typeof obj !== "object" || depth > 8) return false;
  for (const v of Object.values(obj)) {
    if (v == null || v === "") continue;
    if (typeof v === "object" && !Array.isArray(v)) {
      if (objectHasAnyPrimitive(v, depth + 1)) return true;
    } else if (typeof v === "string" && v.trim() !== "") return true;
    else if (typeof v === "number" && Number.isFinite(v)) return true;
    else if (typeof v === "boolean") return true;
  }
  return false;
};

export const hasAsiaAssessmentInput = (data) => {
  if (!data || typeof data !== "object") return false;

  if (String(data.comments ?? "").trim().length > 0) return true;

  const neuro =
    data.nerological_level_of_injury ?? data.neurological_level_of_injury;
  if (typeof neuro === "string" && neuro.trim() !== "") return true;

  const impairment = data.asia_impairment_scale;
  if (typeof impairment === "string" && impairment.trim() !== "") return true;

  if (data.zone_of_partial_preservation != null && data.zone_of_partial_preservation !== "") {
    if (typeof data.zone_of_partial_preservation === "object") {
      if (objectHasAnyPrimitive(data.zone_of_partial_preservation)) return true;
    } else if (String(data.zone_of_partial_preservation).trim() !== "") {
      return true;
    }
  }

  const dap = data.dap;
  const vac = data.vac;
  if (dap === "yes" || dap === "no" || vac === "yes" || vac === "no") return true;

  if (motorSensoryHasAnySelection(data.motor_sensory_scale)) return true;

  for (const k of ["sensory_left", "sensory_right", "motor_left", "motor_right"]) {
    const block = data[k];
    if (block && typeof block === "object" && objectHasAnyPrimitive(block)) return true;
  }

  return false;
};
